/*
  Polypouch Blog JS 2026

  Controls:
  1. Automatic left rail navigation from .pp-section elements
  2. Active rail link while scrolling
  3. Tabbed comparison blocks using .pp-compare
*/

(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function getSectionLabel(section, index) {
    var label = section.querySelector('.pp-h2-label');
    var heading = section.querySelector('.pp-h2');

    if (label && label.textContent.trim()) {
      return label.textContent.trim().replace(/^\d+\s*/, '');
    }

    if (heading && heading.textContent.trim()) {
      return heading.textContent.trim();
    }

    return 'Section ' + String(index + 1).padStart(2, '0');
  }

  function ensureSectionId(section, index) {
    if (section.id) {
      return section.id;
    }

    var heading = section.querySelector('.pp-h2');
    var base = heading && heading.textContent.trim()
      ? heading.textContent.trim()
      : 'section-' + (index + 1);

    var id = base
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    if (!id) {
      id = 'section-' + (index + 1);
    }

    var originalId = id;
    var counter = 2;

    while (document.getElementById(id)) {
      id = originalId + '-' + counter;
      counter += 1;
    }

    section.id = id;
    return id;
  }

  function buildRailNavigation() {
    var railList = document.querySelector('.pp-rail-nav');
    var sections = Array.prototype.slice.call(document.querySelectorAll('.pp-body .pp-section'));

    if (!railList || !sections.length) {
      return;
    }

    railList.innerHTML = '';

    sections.forEach(function (section, index) {
      var id = ensureSectionId(section, index);
      var label = getSectionLabel(section, index);
      var number = String(index + 1).padStart(2, '0');

      var li = document.createElement('li');
      var link = document.createElement('a');
      var numberSpan = document.createElement('span');
      var labelSpan = document.createElement('span');

      link.href = '#' + id;
      numberSpan.className = 'n';
      numberSpan.textContent = number;
      labelSpan.textContent = label;

      link.appendChild(numberSpan);
      link.appendChild(labelSpan);
      li.appendChild(link);
      railList.appendChild(li);
    });
  }

  function setActiveRailLink(id) {
    var links = document.querySelectorAll('.pp-rail-nav a');

    links.forEach(function (link) {
      if (link.getAttribute('href') === '#' + id) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
  }

  function activateScrollSpy() {
    var sections = Array.prototype.slice.call(document.querySelectorAll('.pp-body .pp-section'));

    if (!sections.length || !('IntersectionObserver' in window)) {
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setActiveRailLink(entry.target.id);
        }
      });
    }, {
      root: null,
      rootMargin: '-20% 0px -65% 0px',
      threshold: 0
    });

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function enableSmoothRailScroll() {
    var links = document.querySelectorAll('.pp-rail-nav a');

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var targetId = link.getAttribute('href');

        if (!targetId || targetId.charAt(0) !== '#') {
          return;
        }

        var target = document.querySelector(targetId);

        if (!target) {
          return;
        }

        event.preventDefault();

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        history.replaceState(null, '', targetId);
      });
    });
  }

  function setupCompareTabs() {
    var compareBlocks = document.querySelectorAll('.pp-compare');

    compareBlocks.forEach(function (block) {
      var tabs = Array.prototype.slice.call(block.querySelectorAll('.pp-compare-tab'));
      var panels = Array.prototype.slice.call(block.querySelectorAll('.pp-compare-panel'));

      if (!tabs.length || !panels.length) {
        return;
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function (event) {
          event.preventDefault();

          tabs.forEach(function (item) {
            item.classList.remove('active');
          });

          panels.forEach(function (panel) {
            panel.classList.remove('active');
          });

          tab.classList.add('active');

          var targetId = tab.getAttribute('data-target');
          var targetPanel = targetId ? block.querySelector('#' + targetId) : panels[index];

          if (targetPanel) {
            targetPanel.classList.add('active');
          }
        });
      });
    });
  }

  /*
    This keeps older inline onclick tab markup working:
    onclick="showTab(this,'t1')"
  */
  window.showTab = function (button, tabId) {
    var compareBlock = button.closest('.pp-compare');

    if (!compareBlock) {
      return;
    }

    var tabs = compareBlock.querySelectorAll('.pp-compare-tab');
    var panels = compareBlock.querySelectorAll('.pp-compare-panel');
    var targetPanel = compareBlock.querySelector('#' + tabId);

    tabs.forEach(function (tab) {
      tab.classList.remove('active');
    });

    panels.forEach(function (panel) {
      panel.classList.remove('active');
    });

    button.classList.add('active');

    if (targetPanel) {
      targetPanel.classList.add('active');
    }
  };

  ready(function () {
    buildRailNavigation();
    activateScrollSpy();
    enableSmoothRailScroll();
    setupCompareTabs();

    document.documentElement.classList.add('pp-blog-js-loaded');
  });
})();